// extracted by mini-css-extract-plugin
export default {"heading":"SectionHeading_heading__qma3y","title":"SectionHeading_title__fIUtx","rule":"SectionHeading_rule__7JEBa"};